module.exports = __webpack_public_path__ + "static/media/IMG_2167.ccbaa6bf.jpg";